// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal.css */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  min-height: 537px;
  max-height: 90vh;
  padding: 24px 0px;
  border-radius: 8px;
  max-width: 1120px;
  width: 90vw;
  position: relative;
}

.modal-close {
  position: absolute;
  top: 18px;
  right: 24px;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #373d43;
  background: #f7f9fc;
  width: 40px;
  border-radius: 20px;
  height: 40px;
}

.measurement-guide {
  text-align: center;
}

.measurement-guide h2 {
  margin-bottom: 20px;
}

.measurement-grid {
  display: flex;
  justify-content: space-around;
  margin: 0px 12px;
}

.measurement-row {
  display: flex;
  flex: 1 1 100%;
  justify-content: space-around;
}

.measurement-item {
  text-align: start;
  width: 250px;
}

.measurement-item img {
  width: 100%;
  height: auto;
  max-width: 138px;
}

.header-measurement-table {
  display: flex;
  background: #f7f9fc;
  height: 33.66px;
  text-align: center;
}

.header-item {
  height: 33.66px;
  width: 83px;
  line-height: 33.66px;
  color: #373d43;
  font-weight: bold;
  border-right: 1px solid #e1e9ef;
}

.dimensions-content {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}

.dimension {
  display: flex;
  height: 33.66px;
  color: #777a7c;
}

.dimensions-content > .dimension > div {
  width: 83px;
  height: 33.66px;
  text-align: center;
  line-height: 33.66px;
  border-right: 1px solid #e1e9ef;
  border-bottom: 1px solid #e1e9ef;
}

.dimension-title {
  font-weight: 700;
  color: #373d43;
}

.container-measurement-table {
  border: 1px solid #e1e9ef;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 8px;
}

.no-border {
  border-right: none !important;
}

h3.measurement-item-title {
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  text-align: left;
  color: #373d43;
  margin: 3px 0px;
}

.measurement-guide h2 {
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  border-bottom: 1px solid #e1e9ef;
  text-align: left;
  margin: 0px;
  padding: 26px 24px;
  margin-bottom: 28px;
}

.image-dimension-continer {
  width: 250px;
  height: 204px;
  display: flex;
  justify-content: center;
  background: #f7f9fc;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 10px;
}

.measurement-item-title span {
  font-size: 12px;
  font-weight: 400;
  margin-left: 10px;
}

@media (max-width: 1200px) {
  .modal-content{
    overflow-y: scroll;
    min-height: 537px;
    max-height: 90vh;
    width: 70vw;
  }
  .measurement-grid {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }

  .measurement-row {
    flex-direction: row;
    width: 100%;
  }
}

@media (max-width: 850px) {
  .modal-content{
    overflow-y: scroll;
    min-height: 537px;
    max-height: 90vh;
    width: 85vw;
  }
  .measurement-grid {
    flex-direction: column;
    align-items: center;
    gap: 4rem;
  }

  .measurement-row {
    flex-direction: column;
    width: 100%;
    gap: 4rem;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalDimensions/styles.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,mBAAmB;EACrB;AACF","sourcesContent":["/* Modal.css */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  min-height: 537px;\n  max-height: 90vh;\n  padding: 24px 0px;\n  border-radius: 8px;\n  max-width: 1120px;\n  width: 90vw;\n  position: relative;\n}\n\n.modal-close {\n  position: absolute;\n  top: 18px;\n  right: 24px;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #373d43;\n  background: #f7f9fc;\n  width: 40px;\n  border-radius: 20px;\n  height: 40px;\n}\n\n.measurement-guide {\n  text-align: center;\n}\n\n.measurement-guide h2 {\n  margin-bottom: 20px;\n}\n\n.measurement-grid {\n  display: flex;\n  justify-content: space-around;\n  margin: 0px 12px;\n}\n\n.measurement-row {\n  display: flex;\n  flex: 1 1 100%;\n  justify-content: space-around;\n}\n\n.measurement-item {\n  text-align: start;\n  width: 250px;\n}\n\n.measurement-item img {\n  width: 100%;\n  height: auto;\n  max-width: 138px;\n}\n\n.header-measurement-table {\n  display: flex;\n  background: #f7f9fc;\n  height: 33.66px;\n  text-align: center;\n}\n\n.header-item {\n  height: 33.66px;\n  width: 83px;\n  line-height: 33.66px;\n  color: #373d43;\n  font-weight: bold;\n  border-right: 1px solid #e1e9ef;\n}\n\n.dimensions-content {\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n}\n\n.dimension {\n  display: flex;\n  height: 33.66px;\n  color: #777a7c;\n}\n\n.dimensions-content > .dimension > div {\n  width: 83px;\n  height: 33.66px;\n  text-align: center;\n  line-height: 33.66px;\n  border-right: 1px solid #e1e9ef;\n  border-bottom: 1px solid #e1e9ef;\n}\n\n.dimension-title {\n  font-weight: 700;\n  color: #373d43;\n}\n\n.container-measurement-table {\n  border: 1px solid #e1e9ef;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-top: 8px;\n}\n\n.no-border {\n  border-right: none !important;\n}\n\nh3.measurement-item-title {\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 28px;\n  text-align: left;\n  color: #373d43;\n  margin: 3px 0px;\n}\n\n.measurement-guide h2 {\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 28px;\n  border-bottom: 1px solid #e1e9ef;\n  text-align: left;\n  margin: 0px;\n  padding: 26px 24px;\n  margin-bottom: 28px;\n}\n\n.image-dimension-continer {\n  width: 250px;\n  height: 204px;\n  display: flex;\n  justify-content: center;\n  background: #f7f9fc;\n  align-items: center;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.measurement-item-title span {\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: 10px;\n}\n\n@media (max-width: 1200px) {\n  .modal-content{\n    overflow-y: scroll;\n    min-height: 537px;\n    max-height: 90vh;\n    width: 70vw;\n  }\n  .measurement-grid {\n    flex-direction: column;\n    align-items: center;\n    gap: 32px;\n  }\n\n  .measurement-row {\n    flex-direction: row;\n    width: 100%;\n  }\n}\n\n@media (max-width: 850px) {\n  .modal-content{\n    overflow-y: scroll;\n    min-height: 537px;\n    max-height: 90vh;\n    width: 85vw;\n  }\n  .measurement-grid {\n    flex-direction: column;\n    align-items: center;\n    gap: 4rem;\n  }\n\n  .measurement-row {\n    flex-direction: column;\n    width: 100%;\n    gap: 4rem;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
